
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 19,
  width: 17,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "3.44 1.99 17.12 20.03"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.306 8.613H5.694l1.324 11.725a1 1 0 0 0 .994.887h7.959a1 1 0 0 0 .993-.886l1.342-11.726ZM14.425 11.523l-.97 6.792m-3.88-6.792.97 6.792",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.09 5.702V4.064c0-.703.57-1.273 1.272-1.273h3.276c.703 0 1.273.57 1.273 1.273v1.638",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.238 8.613a1 1 0 0 1-1-1v-.911a1 1 0 0 1 1-1h13.524a1 1 0 0 1 1 1v.91a1 1 0 0 1-1 1H5.238Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 1.6,
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg height=\"19\" width=\"17\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"3.44 1.99 17.12 20.03\"> <path d=\"M18.3063 8.61261H5.6936L7.01788 20.3376C7.07499 20.8432 7.5027 21.2253 8.01156 21.2253H15.9707C16.479 21.2253 16.9064 20.844 16.9642 20.339L18.3063 8.61261Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path> <path d=\"M14.4255 11.5233L13.4553 18.3147M9.57446 11.5233L10.5447 18.3147\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path> <path d=\"M9.08936 5.70201V4.06411C9.08936 3.3612 9.65917 2.79138 10.3621 2.79138H13.6379C14.3408 2.79138 14.9106 3.3612 14.9106 4.06411V5.70201\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\"></path> <path d=\"M5.23828 8.61265C4.686 8.61265 4.23828 8.16494 4.23828 7.61265V6.70203C4.23828 6.14974 4.686 5.70203 5.23828 5.70203H18.7616C19.3139 5.70203 19.7616 6.14974 19.7616 6.70203V7.61265C19.7616 8.16494 19.3139 8.61265 18.7616 8.61265H5.23828Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"1.6\" stroke-linejoin=\"round\"></path> \r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/trash.0f530393ae18f4daa2d4ad862548dbf3.svg"),
        {
          React: SvgTrash,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      